// GoogleMapSettings only. Shared table methods are in tableMixin.js.
export default {
    name: "GoogleMapSettings",
    methods: {
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.formInputs.id = "";
            this.formInputs.google_maps_api_key = "";
            this.$clearValidationStates("#recordForm");
        },
    },
};